export default "__VITE_ASSET__Ce$Bp81W__"